<main role="main" class="not-home-page">
  <div class="row">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="banner"><img src="" alt="" /></div>
          <app-breadcrumb></app-breadcrumb>
        </div>
      </div>
      <div>
        <div class="row">
          <div class="col-md-3 side-bar">
            <div class="selected-item"> </div>
            <nav id="sidebar">
              <app-statique-menu [lg]="outputLg" [cururl]="currentUrl"></app-statique-menu>
            </nav>
          </div>
          <div class="col-md-9">
            <div id="container">
              <!-- <div class="projects">Photothèque</div> -->

              <div class="gallery">

                <div id="blueimp-gallery-carousel"
                  class="blueimp-gallery blueimp-gallery-carousel blueimp-gallery-controls" aria-label="image carousel">
                  <div class="slides" aria-live="off"></div>
                  <h3 class="title"></h3>
                  <a class="prev" aria-controls="blueimp-gallery-carousel" aria-label="previous slide"></a>
                  <a class="next" aria-controls="blueimp-gallery-carousel" aria-label="next slide"></a>
                  <ol class="indicator"></ol>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</main>